import type { User, UserRole } from "../types";
import { appNav } from "../routes/appNavigation";

/** Owner is the default/legacy role: treat missing role as owner so existing accounts keep full access. */
export function isOwner(user: Pick<User, "role"> | null | undefined): boolean {
  return !user?.role || user.role === "owner";
}

export function isOperator(user: Pick<User, "role"> | null | undefined): boolean {
  return user?.role === "operator";
}

export function isPromoter(user: Pick<User, "role"> | null | undefined): boolean {
  return user?.role === "promoter";
}

export function getRole(user: Pick<User, "role"> | null | undefined): UserRole {
  return (user?.role as UserRole) || "owner";
}

/** Per-role landing route, using existing pages only. */
export const ROLE_HOME_ROUTE: Record<UserRole, string> = {
  owner: appNav.calendar(),
  operator: appNav.events(),
  promoter: appNav.calendar(),
};

export function roleHomeRoute(user: Pick<User, "role"> | null | undefined): string {
  return ROLE_HOME_ROUTE[getRole(user)];
}
